import { axiosServices } from "./axiosServices";

export const projectServices = { addNewProject, getProjectListing, getProjectDetails, getProjectDetailsPackageList, createBulkProject, getCategoryForProjects, getDepartmentForProjects ,getProjectFieldList };

function addNewProject(bodyData) {
    return axiosServices
        .postAxios("/v1/internal/projects", bodyData)
        .then((res) => {
            return res;
        });
}

function createBulkProject(bodyData) {
    return axiosServices
        .postAxios("/v1/internal/projects/bulk", bodyData)
        .then((res) => {
            return res;
        });
}

function getProjectListing(param) {
    return axiosServices.getAxios(`/v1/internal/projects${param}`).then((res) => {
        return res;
    });
}

function getProjectDetails(param) {
    return axiosServices.getAxios(`/v1/internal/projects/${param}`).then((res) => {
        return res;
    });
}

function getProjectDetailsPackageList(projectCode, param) {
    return axiosServices.getAxios(`/v1/internal/projects/${projectCode}/packages${param}`).then((res) => {
        return res;
    });
}

function getCategoryForProjects(param) {
    return axiosServices.getAxios(`/v1/internal/category-management/categories`).then((res) => {
        return res;
    });
}

function getDepartmentForProjects(param) {
    return axiosServices.getAxios(`/v1/internal/category-management/departments`).then((res) => {
        return res;
    });
}
function getProjectFieldList(moduleName , page) {
    return axiosServices.getAxios(`/v1/common/field-configs?moduleName=${moduleName}&page=${page}`).then((res) => {
        return res;
    });
}

